<template>
  <section class="networks section">
    <div class="container p-0">
      <ul class="nav nav-tabs mb-4 networks-nav">
        <li class="nav-item">
          <router-link
            :to="`/vendors/${vendor.id}/network/requests`"
            data-v-step="vendorNetworkRequests"
            class="nav-link px-3"
            active-class="active"
          >
            Network Requests
            <badge
              type="pill"
              color="primary"
              class="ml-1"
              v-if="vendor.networks_requests_count"
              >{{ vendor.networks_requests_count }}</badge
            >
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="`/vendors/${vendor.id}/network/mine`"
            data-v-step="myNetwork"
            class="nav-link px-3"
            active-class="active"
          >
            My Network
            <badge
              type="pill"
              color="primary"
              v-if="vendor.networks_count"
              class="ml-1"
              >{{ vendor.networks_count }}</badge
            >
          </router-link>
        </li>
      </ul>
      <router-view></router-view>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "mainNetworks",
  computed: {
    ...mapState(["vendors"]),
    vendor: function () {
      return this.vendors.single;
    },
  },
};
</script>
